import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage

import authReducer from "./authSlice";
import shipmentReducer from "./shipmentSlice";
import addressReducer from "./addressSlice";
import loggerMiddleware from "../middleware/loggerMiddleware";

// Combine reducers
const rootReducer = combineReducers({
  auth: authReducer,
  shipment: shipmentReducer,
  address: addressReducer,
});

// Persist config
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "address","shipment"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // 🔹 Important for redux-persist
    }).concat(loggerMiddleware),
});

const persistor = persistStore(store);

export { store, persistor };
